import { Filter } from '../../../types/filters'

// Re-exportar tipos centralizados
export type {
  ComponentProps,
  FilterOption,
  Filter,
  FilterComponentProps,
  FilterExtraAction
} from '../../../types/filters'

export interface WithAddFilter {
  onSearch: (filters: Filter[]) => void
}

export const orderByArray = (
  stateId: number,
  visibleStates: Array<string | number>,
  fallbackOrder: number = 999
): number => {
  // Convertir el ID a string para buscarlo en el array
  const stateIdStr = stateId.toString()
  const index = visibleStates.findIndex(
    (state) => state.toString() === stateIdStr
  )

  // Si está en el array, usar su posición (índice + 1 para que empiece en 1)
  if (index !== -1) {
    return index + 1
  }

  return fallbackOrder // Si no está en el array, ir al final
}
